export const comments_5588990 = {"data":{"data":[],"links":{}}}